export default __webpack_public_path__ + "static/media/teachers_portal_img.764aabbe.png";